var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 11 58.9.8a49.7 49.7 0 0 1 20.5 8.8l-6 8.6 10 9.9 8.3-5.8c3.7 5.6 6.3 12 7.5 18.8L89 43v14l10.2 1.9c-1.2 7-4 13.5-7.8 19.1l-8-5.6-10 10 5.8 8.2c-6 4.3-12.9 7.3-20.3 8.6L57 89H43l-1.9 10.2a49.8 49.8 0 0 1-20.8-9l5.8-8.3L16 72l-7.9 5.5A49.7 49.7 0 0 1 .8 59L11 57V43L.8 41.1c1.2-6.7 3.8-13 7.4-18.5l8 5.5 9.9-9.9-5.8-8.4c6-4.5 13.1-7.6 20.8-9L43 11h14Zm-7 75a36 36 0 1 0 0-72 36 36 0 0 0 0 72Z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 100A50 50 0 1 0 50 0a50 50 0 0 0 0 100Zm0-4a46 46 0 1 0 0-92 46 46 0 0 0 0 92Z",
    fill: "#000",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 49.9,
    y1: 50,
    x2: 50.1,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 99,
    y1: 1,
    x2: 1,
    y2: 99.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#448F64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00632A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448F64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipGreen);
export default __webpack_public_path__ + "static/media/chip-green.0486637cb8a91001fbf3b85f47d8983d.svg";
export { ForwardRef as ReactComponent };